import { Link } from 'react-router-dom'
import { useSeo } from '@/lib/useSeo'

export function NotFound() {
  useSeo({
    title: 'Not found',
    description: 'The page you requested could not be found.',
    noindex: true,
  })
  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 py-24 text-center">
      <div className="inline-block bg-vice-sunset text-primary font-bold px-4 py-1 rounded text-sm uppercase tracking-wider">
        404
      </div>
      <h1 className="mt-6 text-4xl sm:text-5xl font-bold text-primary">Page not found.</h1>
      <p className="mt-4 text-lg text-neutral-700">
        The page you were looking for isn&apos;t here. It may have moved.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded bg-primary text-white font-semibold hover:bg-primary-dark"
        >
          Home
        </Link>
        <Link
          to="/sitemap"
          className="px-5 py-2.5 rounded border border-neutral-300 font-semibold hover:bg-neutral-50"
        >
          Site index
        </Link>
      </div>
    </section>
  )
}
